var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9h23M16 17l7-8-7-8",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgArrow;